import { call } from 'api';
import type { ErrorType, PositionedBanner } from 'types/misc';

export const show = (
  slot: string,
  successCallback: (resp?: PositionedBanner) => void,
  errorCallback: (error?: ErrorType) => void,
) => call(`positioned-banners/${slot}`, { method: 'GET' }, successCallback, errorCallback, true);
